import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import GoogleDot from '../../images/google_dot.png';
import MicrosoftDot from '../../images/microsoft_dot.svg';
const dotIsPhoneCss = "dlj6c2h";
const dotIsPastCss = "ds14k2e";
const dotIsCancelledCss = "d1uqnr2w";
const dotCss = "d1kyztcw";
const externalMeetingTypeDotImgIsPhoneCss = "e1lhcrhb";
const externalMeetingTypeDotImgIsPastCss = "e1r93aic";
const externalMeetingTypeDotImgIsCancelledCss = "e1gvly0t";
const externalMeetingTypeDotImgCss = "e17t7xnw";
export const Dot = forwardRef(({
  color,
  isPast,
  isCancelled,
  ...props
}, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <div ref={ref} {...props} className={classNames(dotCss, {
    [dotIsPhoneCss]: isPhone,
    [dotIsPastCss]: isPast,
    [dotIsCancelledCss]: isCancelled
  }, props.className)} style={{
    ...(props.style || {}),
    backgroundColor: color
  }} />;
});
export const ExternalMeetingTypeDotImg = forwardRef(({
  isPast,
  isCancelled,
  ...props
}, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <img ref={ref} {...props} alt="logo-icon" className={classNames(externalMeetingTypeDotImgCss, {
    [externalMeetingTypeDotImgIsPhoneCss]: isPhone,
    [externalMeetingTypeDotImgIsPastCss]: isPast,
    [externalMeetingTypeDotImgIsCancelledCss]: isCancelled
  }, props.className)} />;
});
export const handleGetExternalDot = source => {
  const imageMap = {
    GOOGLE: GoogleDot,
    OUTLOOK: MicrosoftDot
  };
  return imageMap[source];
};

require("./dot.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./dot.js");